import Vue from 'vue';

function preventMousewheel(event) {
    event.preventDefault();
}

function preventKeyPress(event) {
    if (event.keyCode === 40 || event.keyCode === 38) {
        event.preventDefault();
    }
}

export default Vue.directive('disableDecrease', {
    inserted(el, binding) {
        const inputEle = el.querySelector('input');
        inputEle?.addEventListener('mousewheel', preventMousewheel);
        inputEle?.addEventListener('keydown', preventKeyPress);
    },
    unbind(el, binding) {
        const inputEle = el.querySelector('input');
        inputEle?.removeEventListener('mousewheel', preventMousewheel);
        inputEle?.removeEventListener('keydown', preventKeyPress);
    },
});
